import { lazy } from "react";


const Login = lazy(() => import("../views/authentication/Login"));
const PreCadastro = lazy(() => import("../views/authentication/preCadastro"));
const EsqueciSenha = lazy(() => import("../views/authentication/EsqueciSenha"));
const ValidarToken = lazy(() => import("../views/authentication/ValidarToken"));

var AuthRoutes = [
  {
    path: "/authentication/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/authentication/pre-cadastro/:token",
    name: "Pre Cadastro",
    component: PreCadastro,
  },
  {
    path: "/authentication/esqueci-senha/validar-token",
    name: "EsqueciSenha",
    component: ValidarToken,
  },
  {
    path: "/authentication/esqueci-senha",
    name: "EsqueciSenha",
    component: EsqueciSenha,
  },

];
export default AuthRoutes;
